import type { Appointment } from './appointment.types';
// Assign overlapping appointments separate lanes. One group shares a consistent lane count.
export function layoutAppointments(items: Appointment[]) {
  const sorted = [...items].sort((a, b) => a.appointment_time_ms - b.appointment_time_ms);
  const groups: Appointment[][] = []; let until = 0;
  for (const item of sorted) {
    const end = item.appointment_time_ms + Math.max(item.duration_minutes, 30) * 60000;
    if (!groups.length || item.appointment_time_ms >= until) { groups.push([item]); until = end; }
    else { groups.at(-1)!.push(item); until = Math.max(until, end); }
  }
  return groups.flatMap(group => {
    const laneEnds: number[] = [];
    const positioned = group.map(item => {
      let lane = laneEnds.findIndex(end => end <= item.appointment_time_ms);
      if (lane < 0) lane = laneEnds.length;
      laneEnds[lane] = item.appointment_time_ms + Math.max(item.duration_minutes, 30) * 60000;
      return { item, lane };
    });
    return positioned.map(p => ({ ...p, lanes: laneEnds.length }));
  });
}
